type Kind = 'Number' | 'Text';

// eslint-disable-next-line
export function modify<T extends Record<string, any>>(kind: Kind | string, object: T, value: string | number): T {
  const kindToAttr: Record<Kind, string> = {
    Number: 'numberAttribute',
    Text: 'textAttribute',
  };

  const key = kindToAttr[kind as Kind];
  if (!key) return object;

  return {
    ...object,
    [key]: {
      // eslint-disable-next-line
      ...(object as any)[key],
      value,
    },
  };
}
